// store/reducers/aboutReducer.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'
import axios from 'axios';
import { api_url } from '../../utils/utils'
// ─── THUNKS ───────────────────────────────────────

export const get_about_settings = createAsyncThunk(
    'about/get_settings',
    async (_, { rejectWithValue, getState }) => {
        //  const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config= {
        //     headers: {
        //         Authorization : `Bearer ${token}`
        //     }
        // }
        try {
            const { data } = await api.get(`${api_url}/api/about/admin`, {withCredentials: true})
            return data.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Xəta')
        }
    }
)

export const update_about_settings = createAsyncThunk(
    'about/update_settings',
    async (formData, { rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: {
        //         Authorization : `Bearer ${token}`
        //     }
        // };
        try {
            const { data } = await api.put(`/about/admin`, formData, {withCredentials: true})
            return data.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Xəta')
        }
    }
)

export const upload_about_image = createAsyncThunk(
    'about/upload_image',
    async (file, { rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: {
        //         Authorization : `Bearer ${token}`
        //     }
        // };
        try {
            const fd = new FormData()
            fd.append('image', file)
            const { data } = await api.post(`/about/upload-image`, fd,{withCredentials: true} )
                
            
            // { success, url, public_id }
            return data
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Yükləmə xətası')
        }
    }
)

export const get_about_gallery = createAsyncThunk(
    'about/get_gallery',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`${api_url}/api/about/gallery`, { withCredentials: true })
            return data.images   // [{ id, url, filename, size, createdAt }]
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Xəta')
        }
    }
)

export const delete_about_image = createAsyncThunk(
    'about/delete_image',
    async (id, { rejectWithValue, getState }) => {
        // const token = getState().auth.token || localStorage.getItem('accessToken');
        // const config = {
        //     headers: {
        //         Authorization : `Bearer ${token}`
        //     }
        // };
        try {
            await api.delete(`/about/gallery/` + id, {withCredentials: true})
            return id
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Silmə xətası')
        }
    }
)

// ─── SLICE ────────────────────────────────────────

const aboutSlice = createSlice({
    name: 'about',
    initialState: {
        settings:      null,
        gallery:       [],
        loader:        false,
        galleryLoader: false,
        uploadLoader:  false,
        successMessage: '',
        errorMessage:  '',
    },
    reducers: {
        clearMessages: (state) => {
            state.successMessage = ''
            state.errorMessage   = ''
        }
    },
    extraReducers: (builder) => {
        builder

        // ── get_about_settings ──
        .addCase(get_about_settings.pending, (state) => {
            state.loader = true
        })
        .addCase(get_about_settings.fulfilled, (state, { payload }) => {
            state.loader   = false
            state.settings = payload
        })
        .addCase(get_about_settings.rejected, (state, { payload }) => {
            state.loader       = false
            state.errorMessage = payload
        })

        // ── update_about_settings ──
        .addCase(update_about_settings.pending, (state) => {
            state.loader = true
        })
        .addCase(update_about_settings.fulfilled, (state, { payload }) => {
            state.loader         = false
            state.settings       = payload
            state.successMessage = 'Uğurla yadda saxlandı'
        })
        .addCase(update_about_settings.rejected, (state, { payload }) => {
            state.loader       = false
            state.errorMessage = payload
        })

        // ── upload_about_image ──
        .addCase(upload_about_image.pending, (state) => {
            state.uploadLoader = true
        })
        .addCase(upload_about_image.fulfilled, (state, { payload }) => {
            state.uploadLoader  = false
            state.successMessage = 'Şəkil yükləndi'
            // gallery-yə əlavə et
            state.gallery.unshift({
                id:       payload.public_id,
                url:      payload.url,
                filename: payload.url.split('/').pop(),
            })
        })
        .addCase(upload_about_image.rejected, (state, { payload }) => {
            state.uploadLoader = false
            state.errorMessage = payload
        })

        // ── get_about_gallery ──
        .addCase(get_about_gallery.pending, (state) => {
            state.galleryLoader = true
        })
        .addCase(get_about_gallery.fulfilled, (state, { payload }) => {
            state.galleryLoader = false
            state.gallery       = payload
        })
        .addCase(get_about_gallery.rejected, (state, { payload }) => {
            state.galleryLoader = false
            state.errorMessage  = payload
        })

        // ── delete_about_image ──
        .addCase(delete_about_image.fulfilled, (state, { payload }) => {
            state.gallery = state.gallery.filter(img => img.id !== payload)
        })
        .addCase(delete_about_image.rejected, (state, { payload }) => {
            state.errorMessage = payload
        })
    }
})

export const { clearMessages } = aboutSlice.actions
export default aboutSlice.reducer
